var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgN8NLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 22,
    viewBox: "0 0 40 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.147949,
    width: 40,
    height: 21,
    fill: "url(#pattern0_6510_30125)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_6510_30125",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6510_30125",
    transform: "matrix(0.00438596 0 0 0.00835422 0 -0.00125313)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6510_30125",
    width: 228,
    height: 120,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOQAAAB4CAYAAADi8161AAAACXBIWXMAAAsSAAALEgHS3X78AAAEzklEQVR4nO3d3XHbMBBFYcqTFlxV0kxSiKtxVUkRykMGDiXxBySB3bvY8z17TEDiISSKEm/3+30C8N+fH79ORfH++XG7uu0bQQLnI1xzNk6CRGqtQ3x2NEyCREq9Q3xWG+Zb74EAaqxjPLJNgkQqHjEe2TZBIg3PGGvHQJBIQSHGYmssBInhKcVYrI2JIDE0xRiLpbERJIalHGPxPEaCBIQQJIYUYXUs5mMlSEAIQWI4kVbHooyZIAEhBAkI4dseGErEl6tz37wHgDFED0EFQeI0ImyPIHEYIfZDkKhGiP1xlhVViNEGQWIXMdohSGwiRlsEiVXEaI8gsYgYfRAkXhCjH4IEhBAkHrA6+uLCAHzpGWOLO0PViH5AIUg0ZxXf2rajRvn++XEjSDTjGeIoeA+JaZquv9QjxjYIEpepxag2nhplzASJSyLu/Mqa/ISH5z3ZPYw239HmU0Q5uTN/HE+f1Gkx2fn/yPDkRpovfBxeIdXuyd5bhvmemaPCuGuor5LPj2N1kKr3ZO8l03xHDnKadKNcegyrTuoo35N9lG2r7jQjUDx4rI1pN0jCGHvbWQ4ESlFujWUzSIUny3IM2eabjUKUe2NYDVJpx7AYS7b5XqGwY5/lfZ3t3t8sBqm4Q/QcU7b5ZucRZe02X4JU3hF6jC3bfPHP++fHzSLMo9t5+Ngjyg7Q6oHMNt9no16hc0brfeHsY8TXr4DpMSDPA9XXChlltSiuTj7bfJ+xOmri2x4JRTsYZfI2TTGfoCtjzjbfHv8HfbBCJsKvAujjpE4CrIpx3H5//xn6yTp61I6+c+7Nd4SfcswsfJCwQYw2eA+JXcRohyABIQSJTayOtggSq4jRHkFiETH6IEhACEFiUfTPa6MiSKwiSnsEiU1EaYsgASEEiV2sknbCX8vKxeWPuLg8ttv9fg+7k57dQZiv7fZRj5esCbT6ycOoB7JICDIRVjh9b9MU84m6MuZs8+3xf9AHK2RCV6LkZWtf/HJ5APxy+aOo467Bj1whhBYHz/n/UI3z5Zbm6quGyi94W+m946jfzrz386MW5st7SLUBzvUYW7b5RvHnx6+71X1BlQ7Kiyd1FHeEnmPKNl91mW/tvnqWVWmHsLqPX+9t1FIay5JRb56rEOXmxx4KO4blGLLNV41CEN5j2P0cUv2e7CNs03PbKgcA7xDmPMdSdWFAth0l23y9KcVYeI3p5WOPPdlOQ2eYr+dHH4oxzlk/P4eDLFTuyW5l5Pl6XfmiHmNh+VydvlJH5Z7sVrLNFz5Or5AYi/VBJsrqWFgdTPm2By6JFpY6gsRlR6OMGLHVmAkSTUSMTBFBYpqmNu+R1C7UjoiTOvjSK6YWZ6hV9D65Q5B4ED2Y3noHyUtWPOCzUl8ECQghSLxglfRDkFhElD4IEquI0h5BYhNR2iJI7CJKOwSJKkRpgyBRrdVt7bCOIHEYYfbDvT1w2kjXqKogSDRRu2IS7jZessJU5Je6FmMnSEAIQQJCCBLmIr5s5VfngIQIEi4irZKWYyVIQAhBwk2EVdJ6jAQJV8pReoyNIOFOMUqvMREkJChF6TkWgoQMhSi9x0CQkJLtVvbPCBJyPMJQiHGauJUAxPX+upZKiAVBIoTWYaqFWBAkwrG+/bqlv4UbzSMH/KhNAAAAAElFTkSuQmCCAA=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgN8NLogo);
export default __webpack_public_path__ + "static/media/n8n-logo.ec6c86a013e0048e287a775fb7d10ac0.svg";
export { ForwardRef as ReactComponent };